const middleware = {}

middleware['productCodeCheck'] = require('..\\middleware\\productCodeCheck.js')
middleware['productCodeCheck'] = middleware['productCodeCheck'].default || middleware['productCodeCheck']

middleware['unknownRoute'] = require('..\\middleware\\unknownRoute.js')
middleware['unknownRoute'] = middleware['unknownRoute'].default || middleware['unknownRoute']

export default middleware
